// ─────────────────────────────────────────────────────────────────────────────
// THE BELL'S NUMBER AND ITS LIST (Carla, 2026-10-21).
//
// After "Mark all as read" the server said unread 0, yet the bell showed 16: it showed "needs
// attention". The bell's badge is UNREAD ONLY now, and it must clear the moment she marks all read,
// in the sidebar, the top bar and anywhere else at once, so the context changes the ONE copy every
// bell reads (CurrentUserContext notificationCounts) before the server answers, and puts it back if
// the server refuses. "Needs attention" is the Dashboard card's number only.
// ─────────────────────────────────────────────────────────────────────────────
import { needsDecision } from './notificationAction';

/** Every notice read and unread 0: what all surfaces show the instant she marks all read. */
export function markAllReadLocally(notifications, counts) {
  return {
    notifications: (notifications || []).map((n) => (n.read ? n : { ...n, read: true })),
    // needsAttention is left as the server said: reading clears it only where the server's rules say.
    counts: counts ? { ...counts, unread: 0 } : null,
  };
}

/**
 * The panel's two groups. `current`: unread, or still needing a decision (read or not). `earlier`:
 * read and needing nothing, shown faded under "Earlier", and what "Clear all" dismisses.
 */
export function bellGroups(notifications) {
  const current = [];
  const earlier = [];
  for (const n of notifications || []) {
    if (!n.read || needsDecision(n)) current.push(n); else earlier.push(n);
  }
  return { current, earlier };
}

/** The bell's name: the unread count in words. null (not loaded yet) names it plainly. */
export function unreadLabel(unread) {
  if (unread == null) return 'Notifications';
  if (unread === 0) return 'No unread notifications';
  return `${unread} unread notification${unread === 1 ? '' : 's'}`;
}
